import * as moment from 'moment';
import { Action, combineReducers } from '@ngrx/store';

import { Job } from '../../app/models';
import {
  ALL,
  HOLD,
  QUEUED,
  PRINT_READY,
  PRINTED,
  SHIPMENTS,
  REPRINT,
  CUT,
  PACKED,
  PACKING
} from '../status-types';

import {
  _CLEAR,
  CREATE_JOB,
  CREATE_JOBS,
  DELETE_JOB,
  DELETE_QUEUED_MTS_JOB,
  GET_JOB_AMOUNTS,
  GET_OA_JOB_AMOUNTS,
  GET_QUEUED_MTS_JOBS,
  GET_JOBS,
  SET_BATCH_LIST_VIEW,
  SET_JOB_DETAILS_VIEW,
  SET_JOB_LIST_VIEW,
  SET_JOB_SHIP_FLAG,
  SET_GHS_LIST,
  SET_STICKER_LIST,
  UPDATE_JOB,
  UPDATE_JOBS
} from '../actions';

const initialJobDetailsViewState = {
  artworkDownloading: <boolean>false,
  loading           : <boolean>false,
  error             : <string>'',
  holdReason        : <string>'',
  holdReleaseAllowed: <boolean>false,
  printersLoading   : <boolean>false,
  sendingToGHSPrinter: <boolean>false
};

const initialJobAmountsState = [
  { amount: 0, status: ALL, icon: 'icon-options', text: 'ALL' },
  { amount: 0, status: HOLD, icon: 'icon-control-pause', text: 'ON_HOLD' },
  { amount: 0, status: QUEUED, icon: 'icon-control-forward', text: 'QUEUED' },
  { amount: 0, status: PRINT_READY, icon: 'icon-docs', text: 'PRINT_READY' },
  { amount: 0, status: PRINTED, icon: 'icon-doc', text: 'PRINTED' },
  { amount: 0, status: SHIPMENTS, icon: 'icon-plane', text: 'SHIPMENTS' }
];

const initialOAJobAmountsState = [
  { amount: 0, status: ALL, icon: 'icon-options', text: 'ALL' },
  { amount: 0, status: HOLD, icon: 'icon-control-pause', text: 'ON_HOLD' },
  { amount: 0, status: QUEUED, icon: 'icon-control-forward', text: 'QUEUED' },
  { amount: 0, status: CUT, icon: 'icon-docs', text: 'CUT' },
  { amount: 0, status: PACKED, icon: 'icon-social-dropbox', text: 'PACKED' },
  { amount: 0, status: PACKING, icon: 'icon-social-dropbox', text: 'PACKING' },
  { amount: 0, status: SHIPMENTS, icon: 'icon-plane', text: 'SHIPMENTS' }
];

const initialJobListViewState = {
  loading: <boolean>false
};

const initialBatchJobListViewState = {
  loading: <boolean>false
};

const initialJobShipFlagViewState = {
  shipFlag: <boolean>false
};

// const initialTotalJobAmountState = {
//   amount: 0, status: ALL, icon: 'icon-options', text: 'ALL'
// };

// const initialHoldJobAmountState = {
//   amount: 0, status: HOLD, icon: 'icon-control-pause', text: 'ON_HOLD';
// };

export function batchJobListViewReducer(state = initialBatchJobListViewState, action: Action) {
  switch (action.type) {
    case SET_BATCH_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

// export function totalJobAmountReducer(state = initialTotalJobAmountState, action: Action) {
//   switch (action.type) {
//     case GET_TOTAL_JOB_AMOUNT:
//       return Object.assign({}, state, { amount: action.payload.amount });
//     default:
//       return state;
//   }
// }

// export function holdJobAmountReducer(state = initialHoldJobAmountState, action: Action) {
//   switch (action.type) {
//     case GET_HOLD_JOB_AMOUNT:
//       return Object.assign({}, state, { amount: action.payload.amount });
//     default:
//       return state;
//   }
// }

// export function queuedJobAmountReducer()

export function queuedMTSJobListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return initialJobAmountsState;
    case CREATE_JOB:
      return action.payload.job.makeToStock && action.payload.job.status === QUEUED && !state.find(job => job.id === action.payload.job.id)
        ? [ ...state, action.payload.job ]
        : state;
    case DELETE_QUEUED_MTS_JOB:
      return state.filter(job => job.id !== action.payload.id);
    case GET_QUEUED_MTS_JOBS:
      return action.payload.jobs;
    default:
      return state;
  }
}

export function jobAmountsReducer(state = initialJobAmountsState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return initialJobAmountsState;
    case GET_JOB_AMOUNTS:
      return state.map((item, index) => {
        return Object.assign({}, item, {
          amount: action.payload.jobAmounts[index]
        });
      });
    default:
      return state;
  }
}

export function oaJobAmountsReducer(state = initialOAJobAmountsState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return initialOAJobAmountsState;
    case GET_OA_JOB_AMOUNTS:
      return state.map((item, index) => {
        return Object.assign({}, item, {
          amount: action.payload.jobAmounts[index]
        });
      });
    default:
      return state;
  }
}

export function jobDetailsViewReducer(state = initialJobDetailsViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialJobDetailsViewState);
    case SET_JOB_DETAILS_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};

export function jobListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_JOB:
      const match = state.find(job => action.payload.job && job.id === action.payload.job.id);
      return !match
        ? [ ...state, action.payload.job ].sort(sortJobs)
        : state;
    case CREATE_JOBS:
      return [ ...state, ...action.payload.jobs ].sort(sortJobs);
    case DELETE_JOB:
      return state.filter(job => job.id !== action.payload.id);
    case GET_JOBS:
      return action.payload.jobs.length
        ? action.payload.jobs.sort(sortJobs)
        : [];
    case UPDATE_JOB:
      return state.map(job => {
        return job.id === action.payload.id
          ? updateJob(job,action.payload.diffList)
          : job;
      });
    case UPDATE_JOBS:
      return state.map(stateJob => {
        const match = action.payload.jobs.find(job => job.id === stateJob.id);
        return !match ? stateJob : match;
      });
    default:
      return state;
  }
}

export function ghsListReducer(state = {} , action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case SET_GHS_LIST:
      return action.payload.ghsList.sort(sortJobs);
    default:
        return state; 
  }
}

export function stickerListReducer(state = {} , action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case SET_STICKER_LIST:
      return action.payload.stickerList.sort(sortJobs);
    default:
        return state; 
  }
}

export function jobListViewReducer(state = initialJobListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialJobListViewState);
    case SET_JOB_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function jobShipFlagViewReducer(state = initialJobShipFlagViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialJobShipFlagViewState);
    case SET_JOB_SHIP_FLAG:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

function updateJob(job: Job, diffList): any {
  console.log(`inside update job : ${JSON.stringify(job)} , difflist : ${JSON.stringify(diffList)}}`)
  diffList.forEach(diff => {
    if(diff.path === "activity_history") {
      var newActs = job["activity_history"].concat(diff.newVal);
      job["activity_history"] = newActs;
    } else if (diff.path === "jobStatus") {
      job['status'] = diff.newVal;
    } else if(diff.path.startsWith('oaDetails.')){
      const pathParts = diff.path.split('.');

      if (pathParts.length === 3) { 
        job.oaDetails[pathParts[1]][pathParts[2]] = diff.newVal;
      } 

    }else if (diff.path.startsWith('rfid_artworks.')) {
      // Handle nested paths for rfid_artworks only
      const pathParts = diff.path.split('.');
      if (pathParts.length === 3) { // rfid_artworks.{key}.{property}
        job.rfid_artworks[pathParts[1]][pathParts[2]] = diff.newVal;
      }
    } else {
      job[diff.path] = diff.newVal;
    }
  });
  return job;
}


function sortJobs(job1, job2) {
  const date1 = new Date(job1.dueDate);
  const date2 = new Date(job2.dueDate);

  return +date1 - +date2;     // Date Descending
}

export const jobReducers = combineReducers({
  batchJobListView: batchJobListViewReducer,
  jobAmounts      : jobAmountsReducer,
  oaJobAmounts    : oaJobAmountsReducer,
  jobDetailsView  : jobDetailsViewReducer,
  jobList         : jobListReducer,
  ghsList         : ghsListReducer,
  stickerList     : stickerListReducer,
  jobListView     : jobListViewReducer,
  jobShipFlagView : jobShipFlagViewReducer,
  queuedMTSJobList: queuedMTSJobListReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/jobs.ts